import React from 'react';
import { Container, Row, Table } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { Section, SpinnerArea } from '../../../../shared/components';
import useService from '../../../../shared/hooks/useService';
import operTimelineService from '../../../../services/operTimelineService';
import { customDateStr } from '../../../../shared/misc/utils';

const UserMilestonesEditHistory: React.FC<{ operationId: number; milestoneId: number | null }> = ({
  operationId,
  milestoneId,
}) => {
  const { t } = useTranslation();

  const [data, loading] = useService(async () =>
    operTimelineService.getUserMilestonesEditHistory(operationId, milestoneId)
  );

  return (
    <Container>
      <Row>
        <Section className="card-body-indicators">
          <SpinnerArea loading={loading}>
            {data ? (
              <Table className="table--bordered">
                <thead>
                  <tr>
                    <th>{t('userName')}</th>
                    <th>{t('compassDate')}</th>
                    <th>{t('lastModification')}</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((historyItem) => (
                    <tr key={historyItem.milestoneId}>
                      <td>{historyItem.modifiedBy}</td>
                      {customDateStr(historyItem.compassDate) ? (
                        <td>{customDateStr(historyItem.compassDate)}</td>
                      ) : (
                        <td>{t('notSet')}</td>
                      )}
                      <td>{customDateStr(historyItem.modifiedOn)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : null}
          </SpinnerArea>
        </Section>
      </Row>
    </Container>
  );
};

export default UserMilestonesEditHistory;
